import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/img/Icons/success-checkmark-icon.svg'
import _imports_1 from '@assets/img/Rolling-loading.svg'
import _imports_2 from '@/assets/img/Icons/buttons/plus.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-6e1e31f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "your_card_activate_box"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/acssept/img/icon/success-checkmark-icon.svg",
    alt: ""
  })
], -1))
const _hoisted_3 = {
  key: 1,
  class: "your_card_activate_box"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/acssept/img/icon/error-checkmark-icon.svg",
    alt: ""
  })
], -1))
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 3,
  class: "your_card_activate_box"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_8 = { class: "field form-group" }
const _hoisted_9 = { class: "error" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "loader"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "wrapper-btn" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr-3",
  src: _imports_2
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_aba_button = _resolveComponent("aba-button")!
  const _component_modal_fullscreen = _resolveComponent("modal-fullscreen")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_modal_fullscreen, {
      visible: _ctx.visible,
      onClose: _ctx.close,
      hideFooter: _ctx.IsSuccess
    }, _createSlots({
      body: _withCtx(() => [
        (_ctx.AcquiringPayinSuccess === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("p", null, _toDisplayString(_ctx.$store.getters.translation({
                  Key: "TheBalanceOnCardBeenSuccessfullyReplenished",
                })) + "! ", 1)
            ]))
          : (_ctx.AcquiringPayinSuccess === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("p", null, _toDisplayString(_ctx.$store.getters.translation({
                  Key: "TheBalanceOnCardBeenErrorReplenished",
                })) + "! ", 1)
              ]))
            : _createCommentVNode("", true),
        (!_ctx.IsSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$localization.getTranslate("AcquiringRefillMessage")) + ". ", 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("p", null, _toDisplayString(_ctx.$localization.getTranslate(
                "TheBalanceOnCardBeenSuccessfullyReplenished"
              )) + "! ", 1)
            ]))
      ]),
      _: 2
    }, [
      (!_ctx.IsSuccess)
        ? {
            name: "header",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("RechargeCard")), 1)
            ]),
            key: "0"
          }
        : undefined,
      (!_ctx.IsSuccess)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ui_input, {
                    type: "number",
                    class: "input-amount",
                    modelValue: _ctx.Amount,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.Amount) = $event)),
                    headerText: _ctx.$localization.getTranslate('Amount')
                  }, null, 8, ["modelValue", "headerText"])
                ]),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.ErrorMessage), 1),
                _createTextVNode(" Commission: " + _toDisplayString(_ctx.Commission) + " EUR ", 1),
                _createElementVNode("div", {
                  class: _normalizeClass([{ active: _ctx.IsLoad }, "loader-gif inline"])
                }, _hoisted_11, 2),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_aba_button, {
                      class: "m-2",
                      btnType: "active",
                      onClick: _ctx.replenishment
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Replenish")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ])
            ]),
            key: "1"
          }
        : undefined
    ]), 1032, ["visible", "onClose", "hideFooter"])
  ]))
}